import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTPROMOCODEBLOCK_LEGACY_FIELD_ORDER = [
  "primary_button_background_color",
  "primary_button_text_color",
  { type: 'separator' },
  "secondary_button_background_color",
  "secondary_button_text_color",
  { type: 'separator' },
  "background_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartPromoCodeBlockDescriptor: _generatedKioskCartPromoCodeBlockDescriptor,
  kioskCartPromoCodeBlockBlocDefinition,
  kioskCartPromoCodeBlockDashboardLayout,
  kioskCartPromoCodeBlockConfig,
  kioskCartPromoCodeBlockResolveConfig,
  kioskCartPromoCodeBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart - Promo Code",
    componentType: 'KioskCartPromoCodeBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart - Promo Code.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskCartPageComponent', slot: 'body' },
    ],


    sharedFields: {}
  },

  () => ({
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.secondary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-cart-promo-code.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-promo-code.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-promo-code.fieldset.field.label",
            fields: ["background_color", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-promo-code.fieldset.apply-button.label",
            fields: ["primary_button_background_color", "primary_button_text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-promo-code.fieldset.remove-button.label",
            fields: ["secondary_button_background_color", "secondary_button_text_color"],
          },
        ],
      },
    ],
  })
);

export function kioskCartPromoCodeBlockDescriptor(): IBlockDescriptor;
export function kioskCartPromoCodeBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartPromoCodeBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartPromoCodeBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartPromoCodeBlockDescriptor, kioskCartPromoCodeBlockProperties, fieldOrder);
}

export {
  kioskCartPromoCodeBlockBlocDefinition,
  kioskCartPromoCodeBlockDashboardLayout,
  kioskCartPromoCodeBlockProperties,
  kioskCartPromoCodeBlockConfig,
  kioskCartPromoCodeBlockResolveConfig,
};

export type KioskCartPromoCodeBlockConfig = typeof kioskCartPromoCodeBlockConfig;
